import { render, staticRenderFns } from "./OfferDifferentPriceDialog.vue?vue&type=template&id=2953b9c6"
import script from "./OfferDifferentPriceDialog.vue?vue&type=script&lang=js"
export * from "./OfferDifferentPriceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports